/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './topics-panel.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../../../shared/svg-icon/svg-icon.component.ngfactory';
import * as i5 from '../../../../../app/shared/svg-icon/svg-icon.component';
import * as i6 from '../../../../../app/shared/translations/translate.directive';
import * as i7 from '../../../../../app/shared/translations/translations.service';
import * as i8 from '../../../../../app/shared/settings.service';
import * as i9 from '../../../../../app/help-center/front/topics-panel/topics-panel.component';
import * as i10 from '../../../../../app/help-center/shared/hc-urls.service';
const styles_TopicsPanelComponent:any[] = [i0.styles];
export const RenderType_TopicsPanelComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_TopicsPanelComponent,data:{}});
function View_TopicsPanelComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),8,'a',[['class',
      'category']],[[2,'active',(null as any)],[1,'target',0],[8,'href',4]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1).onClick($event.button,$event.ctrlKey,$event.metaKey,
          $event.shiftKey)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i2.RouterLinkWithHref,
      [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'svg-icon',[['name','folder-open']],(null as any),
      (null as any),(null as any),i4.View_SvgIconComponent_0,i4.RenderType_SvgIconComponent)),
      i1.ɵdid(114688,(null as any),0,i5.SvgIconComponent,[i1.ElementRef,i1.Renderer2],
          {name:[0,'name']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',[['class','category-name']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),['\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_3:any = _co.urls.getCategoryLink(_v.context.$implicit);
        _ck(_v,1,0,currVal_3);
        const currVal_4:any = 'folder-open';
        _ck(_v,4,0,currVal_4);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (_co.category.id == _v.context.$implicit.id);
        const currVal_1:any = i1.ɵnov(_v,1).target;
        const currVal_2:any = i1.ɵnov(_v,1).href;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
        const currVal_5:any = _v.context.$implicit.name;
        _ck(_v,7,0,currVal_5);
      });
}
export function View_TopicsPanelComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'div',[['class',
      'title'],['trans','']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(4341760,(null as any),0,i6.TranslateDirective,[i1.ElementRef,
      i7.Translations,i8.SettingsService],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
      ['Related Content'])),(_l()(),i1.ɵted((null as any),['\n\n'])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),4,'div',[['class','categories-list']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
      ['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_TopicsPanelComponent_1)),i1.ɵdid(802816,(null as any),0,i3.NgForOf,[i1.ViewContainerRef,
      i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i9.TopicsPanelComponent = _v.component;
    const currVal_0:any = _co.topics;
    _ck(_v,7,0,currVal_0);
  },(null as any));
}
export function View_TopicsPanelComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'topics-panel',
      ([] as any[]),(null as any),(null as any),(null as any),View_TopicsPanelComponent_0,
      RenderType_TopicsPanelComponent)),i1.ɵdid(114688,(null as any),0,i9.TopicsPanelComponent,
      [i10.HcUrls],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TopicsPanelComponentNgFactory:i1.ComponentFactory<i9.TopicsPanelComponent> = i1.ɵccf('topics-panel',
    i9.TopicsPanelComponent,View_TopicsPanelComponent_Host_0,{category:'category'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvaGVscC1jZW50ZXIvZnJvbnQvdG9waWNzLXBhbmVsL3RvcGljcy1wYW5lbC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2UvYXBwcy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9oZWxwLWNlbnRlci9mcm9udC90b3BpY3MtcGFuZWwvdG9waWNzLXBhbmVsLmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvaGVscC1jZW50ZXIvZnJvbnQvdG9waWNzLXBhbmVsL3RvcGljcy1wYW5lbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvaGVscC1jZW50ZXIvZnJvbnQvdG9waWNzLXBhbmVsL3RvcGljcy1wYW5lbC5jb21wb25lbnQudHMuVG9waWNzUGFuZWxDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwidGl0bGVcIiB0cmFucz5SZWxhdGVkIENvbnRlbnQ8L2Rpdj5cclxuXHJcbjxkaXYgY2xhc3M9XCJjYXRlZ29yaWVzLWxpc3RcIj5cclxuICAgIDxhIGNsYXNzPVwiY2F0ZWdvcnlcIiAqbmdGb3I9XCJsZXQgdG9waWMgb2YgdG9waWNzXCIgW2NsYXNzLmFjdGl2ZV09XCJjYXRlZ29yeS5pZCA9PSB0b3BpYy5pZFwiIFtyb3V0ZXJMaW5rXT1cInVybHMuZ2V0Q2F0ZWdvcnlMaW5rKHRvcGljKVwiPlxyXG4gICAgICAgIDxzdmctaWNvbiBuYW1lPVwiZm9sZGVyLW9wZW5cIj48L3N2Zy1pY29uPlxyXG4gICAgICAgIDxzcGFuIGNsYXNzPVwiY2F0ZWdvcnktbmFtZVwiPnt7dG9waWMubmFtZX19PC9zcGFuPlxyXG4gICAgPC9hPlxyXG48L2Rpdj4iLCI8dG9waWNzLXBhbmVsPjwvdG9waWNzLXBhbmVsPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0dJO01BQUE7TUFBQTtJQUFBO0lBQUE7TUFBQTtVQUFBO01BQUE7SUFBQTtJQUFBO0VBQUEsdUNBQUE7TUFBQTtNQUFBLGVBQXFJLCtDQUNqSTtNQUFBO01BQUE7YUFBQTtVQUFBLGlDQUF3QztNQUN4QztVQUFBO01BQTRCLHdDQUFxQjs7O1FBRnFDO1FBQTFGLFdBQTBGLFNBQTFGO1FBQ2M7UUFBVixXQUFVLFNBQVY7OztRQUQ2QztRQUFqRDtRQUFBO1FBQUEsV0FBaUQsVUFBakQsbUJBQUE7UUFFZ0M7UUFBQTs7OztvQkFMcEM7TUFBQTtNQUFBLHVCQUFBO3dDQUFBLCtCQUF5QjtNQUFBLHNCQUFxQix5Q0FFOUM7TUFBQTtNQUFBLDBEQUE2QjtNQUFBLGFBQ3pCO01BQUEscUNBQUE7dUNBQUEseUNBR0k7YUFBQTs7SUFIZ0I7SUFBcEIsV0FBb0IsU0FBcEI7Ozs7b0JDSEo7TUFBQTtxQ0FBQSxVQUFBO01BQUE7SUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/help-center/front/topics-panel/topics-panel.component.ngfactory.ts